import React from 'react';

export default function StepWallet({ form, handleChange, next, prev }) {
  // Validate Ethereum address (0x followed by 40 hex characters)
  const isValidAddress = (address) => {
    if (!address) return false;
    return /^0x[a-fA-F0-9]{40}$/.test(address);
  };

  const isValid = isValidAddress(form.walletEth);

  return (
    <div style={{ textAlign: 'center' }}>
      <h2 style={{
        fontFamily: "'Patrick Hand', cursive",
        fontSize: '28px', fontWeight: '900', color: '#2d2d2d',
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: '8px'
      }}>ENTER WALLET ADDRESS</h2>

      <p style={{ 
        color: '#2d2d2d', 
        fontSize: '14px', 
        marginBottom: '24px',
        fontFamily: "'Patrick Hand', cursive" 
      }}>
        Your ETH wallet address for the whitelist
      </p>

      <input 
        name="walletEth" 
        placeholder="0x..."
        value={form.walletEth} 
        onChange={handleChange}
        style={{
          width: '100%', padding: '16px', background: '#fff',
          border: isValid || !form.walletEth ? '3px solid #2d2d2d' : '3px solid #d32f2f',
          borderRadius: '12px',
          color: '#2d2d2d', fontSize: '16px',
          fontFamily: "'Patrick Hand', cursive",
          marginBottom: '8px', outline: 'none', boxSizing: 'border-box',
          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
        }}
      />

      {/* Validation message */}
      {!isValid && form.walletEth && (
        <p style={{ 
          color: '#d32f2f', 
          fontSize: '13px', 
          marginBottom: '16px',
          fontFamily: "'Patrick Hand', cursive",
          fontWeight: '600',
          textAlign: 'left'
        }}>
          ⚠️ Must be a valid ETH address (0x + 40 hex characters)
        </p>
      )}

      <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
        <button onClick={prev} style={{
          flex: 1, padding: '16px', background: '#fff',
          border: '3px solid #2d2d2d', borderRadius: '12px',
          color: '#2d2d2d', fontSize: '16px', fontWeight: '900',
          fontFamily: "'Patrick Hand', cursive",
          cursor: 'pointer', boxShadow: '0 6px 0 #2d2d2d',
          transform: 'skewX(-5deg)',
          transition: 'all 0.1s ease'
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = 'skewX(-5deg) translateY(4px)';
          e.currentTarget.style.boxShadow = '0 2px 0 #2d2d2d';
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = 'skewX(-5deg) translateY(0)';
          e.currentTarget.style.boxShadow = '0 6px 0 #2d2d2d';
        }}
        >
          <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
            ← BACK
          </span>
        </button>
        
        <button 
          onClick={next} 
          disabled={!isValid}
          style={{
            flex: 1, padding: '16px',
            background: isValid 
              ? 'linear-gradient(180deg, #5cb85c 0%, #4cae4c 100%)' 
              : '#8b8b8b',
            border: '3px solid #2d2d2d', 
            borderRadius: '12px',
            color: '#fff', 
            fontSize: '16px', 
            fontWeight: '900',
            fontFamily: "'Patrick Hand', cursive",
            cursor: isValid ? 'pointer' : 'not-allowed',
            transform: isValid ? 'skewX(-5deg)' : 'skewX(-5deg) scale(0.98)',
            boxShadow: isValid ? '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)' : '0 2px 0 #2d2d2d',
            opacity: isValid ? 1 : 0.6,
            transition: 'all 0.1s ease'
          }}
          onMouseDown={(e) => {
            if (!isValid) return;
            e.currentTarget.style.transform = 'skewX(-5deg) translateY(4px)';
            e.currentTarget.style.boxShadow = '0 2px 0 #2d2d2d';
          }}
          onMouseUp={(e) => {
            if (!isValid) return;
            e.currentTarget.style.transform = 'skewX(-5deg) translateY(0)';
            e.currentTarget.style.boxShadow = '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)';
          }}
        >
          <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
            {isValid ? 'NEXT →' : 'INVALID ADDRESS'}
          </span>
        </button>
      </div>
    </div>
  );
}